export default __webpack_public_path__ + "static/media/VisbyCF-Medium.2a57f5ff.otf";